
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Definição de tipos para o objeto global do Facebook Pixel
declare global {
  interface Window {
    fbq?: any; // Usando any para resolver os erros de tipagem com push, loaded, etc
    _fbq?: any;
  }
}

// ID real do seu Pixel do Meta
const FB_PIXEL_ID = '850596020599773';

const MetaPixel = () => {
  const location = useLocation();

  useEffect(() => {
    // Função para carregar o script do Facebook Pixel
    const loadFbPixel = () => {
      // Verifica se o script já foi carregado
      if (window.fbq) return;
      
      // Inicializa o objeto fbq
      window.fbq = function() {
        // @ts-ignore
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      
      // Se a fila não existe, cria uma
      if (!window._fbq) window._fbq = window.fbq;
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
      
      // Carrega o script do Pixel
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
      
      // Inicializa o Pixel
      window.fbq('init', FB_PIXEL_ID);
      
      // Log para debug
      console.log('[Meta Pixel] Initialized with ID:', FB_PIXEL_ID);
    };
    
    // Carrega o script do Pixel
    loadFbPixel();
    
    // Dispara evento de PageView
    if (window.fbq) {
      window.fbq('track', 'PageView');
      console.log('[Meta Pixel] PageView event tracked');
    }
    
    // Cleanup function
    return () => {
      // Não é possível remover completamente o script do Facebook,
      // mas podemos limpar quaisquer listeners específicos se necessário
    };
  }, []); // Executa apenas uma vez na montagem do componente
  
  // Rastreia mudanças de página (no React Router)
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      console.log('[Meta Pixel] PageView event tracked on route change:', location.pathname);
    }
  }, [location.pathname]); // Executa sempre que o caminho da página mudar
  
  return null; // Componente não renderiza nada visualmente
};

export default MetaPixel;
